export default "__VITE_ASSET__DMQRJiUE__"